<template>
  <v-row>
    <v-dialog
    v-model="show"
      scrollable
      persistent
      max-width="700px"
    >
    <v-card>
        <v-card-text class="mt-8">
            <table>
                <tr>
                    <td style="width:45%;font-weight:bold;">{{ $t('user') }}</td>
                    <td style="width:35%;font-weight:bold;">{{ $t('operation') }}</td>
                    <td style="width:20%;font-weight:bold;">{{ $t('time') }}</td>
                <tr>
                <tr v-for="(operation, k) in operations" :key="k">
                    <td style="width:45%">{{ operation.user }}</td>
                    <td style="width:35%">{{ operation.operationDescription }}</td>
                    <td style="width:20%">{{ operation.dateTime }}</td>
                </tr>
            </table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
    export default {
        name: "OperationDialog",
        props: ['operations'],
        data () {
        return {
            show: this.$parent.showOperation
            }
        },
        methods: {
            closeDialog() {
                this.$parent.showOperation = false
            }
        }
    }
</script>   